import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { Mail } from 'feather-icons-react/build/IconComponents';
import apiClient from '../../../services/apiClient';
import { useAuth } from '../../../contexts/AuthContext';
import { defaultHomePath } from '../../../lib/homePath';
import AuthLayout from './AuthLayout';
import styles from './Login.module.css';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading, user } = useAuth();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  // Already logged in — recovering a password makes no sense mid-session,
  // send them back to their dashboard instead of showing the form.
  if (!isLoading && isAuthenticated) {
    return <Navigate to={defaultHomePath(user)} replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email.trim()) {
      setError('Ingrese su correo electrónico.');
      return;
    }

    setLoading(true);
    try {
      await apiClient.post('/forgot-password', { email });
      setSent(true);
    } catch (err) {
      // Still show success to prevent email enumeration
      if (err?.response?.status !== 500) {
        setSent(true);
      } else {
        setError('Error del servidor. Intente de nuevo más tarde.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout loading={loading}>
      {sent ? (
        <>
          <div className={styles.formHeader}>
            <h2>Revise su correo</h2>
            <p>
              Si el correo está registrado, recibirá instrucciones para restablecer
              su contraseña.
            </p>
          </div>

          <button
            type="button"
            className={styles.submit}
            onClick={() => navigate('/login')}
          >
            Volver al Inicio de Sesión
          </button>
        </>
      ) : (
        <>
          <div className={styles.formHeader}>
            <h2>Recuperar contraseña</h2>
            <p>Ingrese su correo y le enviaremos instrucciones para restablecerla</p>
          </div>

          {error && (
            <div className="alert alert-danger mb-3" role="alert">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} aria-busy={loading}>
            <div className={styles.field}>
              <label htmlFor="ec-forgot-email" className={styles.fieldLabel}>Correo electrónico</label>
              <div className={styles.fieldWrap}>
                <span className={styles.fieldIcon} aria-hidden="true">
                  <Mail size={18} />
                </span>
                <input
                  id="ec-forgot-email"
                  type="email"
                  className={styles.input}
                  placeholder="tu@clinica.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                  autoComplete="email"
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              className={styles.submit}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                  Enviando...
                </>
              ) : (
                'Enviar Instrucciones'
              )}
            </button>
          </form>

          <p className="text-center mt-3">
            ¿Recordó su contraseña? <Link to="/login">Iniciar Sesión</Link>
          </p>
        </>
      )}
    </AuthLayout>
  );
};

export default ForgotPassword;
